"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UniswapV3 = void 0;
const weth_1 = require("./weth");
const adapter_1 = __importDefault(require("./adapter"));
const UNISWAP_V3_ROUTER_ABI = require("../../abi/uniswap.v3.router.json");
const ERC20_ABI = require("../../abi/erc20.json");
const UNISWAP_V3_ROUTER_ADDRESSES = {
    1: '0xE592427A0AEce92De3Edee1F18E0157C05861564',
};
class UniswapV3 extends adapter_1.default {
    constructor(network, web3Provider, augustus) {
        super(network, web3Provider, augustus);
        this.network = network;
        this.web3Provider = web3Provider;
        this.augustus = augustus;
        this.swapRouterAddress = UNISWAP_V3_ROUTER_ADDRESSES[this.network];
        this.router = new this.web3Provider.eth.Contract(UNISWAP_V3_ROUTER_ABI, this.swapRouterAddress);
    }
    static getDexData(optimalRate, name) {
        return {
            name,
            srcAmount: optimalRate.srcAmount,
            destAmount: '1',
            fee: optimalRate.data.fee,
            deadline: optimalRate.data.deadline,
            sqrtPriceLimitX96: optimalRate.data.sqrtPriceLimitX96 || '0',
        };
    }
    ethToTokenSwap(srcToken, destToken, data) {
        return __awaiter(this, void 0, void 0, function* () {
            const wethToken = weth_1.Weth.getAddress(this.network);
            const wethContract = new this.web3Provider.eth.Contract(ERC20_ABI, wethToken);
            const depositWethData = wethContract.methods.deposit().encodeABI();
            const wethToTokenData = yield this.getTokenToTokenSwapData(wethToken, destToken, data);
            return {
                callees: [wethToken, ...wethToTokenData.callees],
                calldata: [depositWethData, ...wethToTokenData.calldata],
                values: [data.srcAmount, ...wethToTokenData.values],
            };
        });
    }
    tokenToEthSwap(srcToken, destToken, data) {
        return __awaiter(this, void 0, void 0, function* () {
            const wethToken = weth_1.Weth.getAddress(this.network);
            const wethToTokenData = yield this.getTokenToTokenSwapData(srcToken, wethToken, data);
            const withdrawWethData = this.augustus.methods
                .withdrawAllWETH(wethToken)
                .encodeABI();
            return {
                callees: [...wethToTokenData.callees, this.augustus._address],
                calldata: [...wethToTokenData.calldata, withdrawWethData],
                values: [...wethToTokenData.values, '0'],
            };
        });
    }
    tokenToTokenSwap(srcToken, destToken, data) {
        return __awaiter(this, void 0, void 0, function* () {
            const swapData = yield this.getTokenToTokenSwapData(srcToken, destToken, data);
            return {
                callees: [...swapData.callees],
                calldata: [...swapData.calldata],
                values: [...swapData.values],
            };
        });
    }
    getTokenToTokenSwapData(srcToken, destToken, data) {
        return __awaiter(this, void 0, void 0, function* () {
            const approveCallData = yield this.getApproveCallData(srcToken, data.srcAmount, this.swapRouterAddress);
            const assetSwapperData = this.buildSwapData(srcToken, destToken, data);
            const callees = approveCallData
                ? [this.augustus._address, this.swapRouterAddress]
                : [this.swapRouterAddress];
            const calldata = approveCallData
                ? [approveCallData.calldata, assetSwapperData]
                : [assetSwapperData];
            const networkFees = this.getNetworkFees(srcToken, destToken);
            const values = approveCallData ? ['0', networkFees] : [networkFees];
            return {
                callees,
                calldata,
                values,
            };
        });
    }
    buildSwapData(srcToken, destToken, data) {
        const exactInputSingleParams = {
            tokenIn: srcToken,
            tokenOut: destToken,
            fee: data.fee,
            recipient: this.augustus._address,
            deadline: data.deadline || this.getDeadline(),
            amountIn: data.srcAmount,
            amountOutMinimum: data.destAmount,
            sqrtPriceLimitX96: data.sqrtPriceLimitX96 || '0',
        };
        const swapData = this.router.methods
            .exactInputSingle(exactInputSingleParams)
            .encodeABI();
        return swapData;
    }
}
exports.UniswapV3 = UniswapV3;
//# sourceMappingURL=uniswap-v3.js.map